import React, { useState } from 'react'
import cn from 'classnames'

import AskAboutPuppyModal from './AskAboutPuppyModal'
import styles from './btnCall.module.scss'

export default function ButtonAsk({ special, dataPuppy }) {
  const [openModal, setOpenModal] = useState(false)
  return (
    <>
      <button
        onClick={() => setOpenModal(true)}
        className={cn({ [styles.btnAsk]: true, [styles.special]: special })}
      >
        <div className={styles.chat} />
        <div className={styles.containerText}>
          <span className={styles.title}>Ask About Me</span>
        </div>
      </button>
      <AskAboutPuppyModal
        dataPuppy={dataPuppy}
        isOpen={openModal}
        close={() => {
          setOpenModal(false)
        }}
      />
    </>
  )
}
